import { IBroadcastCommandEventOption } from '@/interfaces';
import { broadcastService } from '..';

export const events = {

  publish: <TData = any>(payload: IBroadcastCommandEventOption<TData>) =>
    broadcastService
      .publish<IBroadcastCommandEventOption<TData>>({ type: 'events', payload })

};
